import * as api from '@gitbook/api-client';
import { Description, FieldGroup, Group, Label, Panel, PanelBody } from '@gitbook/spine-react';

import { useSiteContext, useUpgradeSite } from '../../../state';
import { ContentReferenceInput } from '../../ContentReferences';
import { PaidFeatureIndicator } from '../../Site/PaidFeatureIndicator';
import type { SitesCustomizationPanelProps } from '../types';

export function PrimaryLinkSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;
    const headerPrimaryLink = settings.header.primaryLink ?? null;

    const { site } = useSiteContext();
    const upgrade = useUpgradeSite(site, api.SiteFeatureKey.SitesAdvancedCustomization);

    const setPrimaryLink = (link: api.ContentRef | null) => {
        setSettings((prev) => ({
            ...prev,
            header: {
                ...prev.header,
                primaryLink: link ?? undefined,
            },
        }));
    };

    return (
        <Panel aria-label="Primary link">
            <PanelBody>
                <FieldGroup orientation="vertical">
                    <Group orientation="vertical">
                        <Group>
                            <Label>Primary link</Label>
                            <PaidFeatureIndicator
                                upgrade={upgrade}
                                isFeatureActive={!!settings.header.logo}
                            />
                        </Group>
                        <Description>
                            The destination to open when visitors click the site title or logo in
                            the header. Leave empty to link to the homepage of the docs.
                        </Description>
                    </Group>
                    <ContentReferenceInput
                        placeholder="Search for content or type a URL…"
                        value={headerPrimaryLink}
                        onChange={setPrimaryLink}
                        size="medium"
                        accept={['url', 'anchor', 'page', 'space']}
                        clearable
                    />
                </FieldGroup>
            </PanelBody>
        </Panel>
    );
}
